__turbopack_context__.v({
  "clearBtn": "package-name-search-module__rhuPwa__clearBtn",
  "empty": "package-name-search-module__rhuPwa__empty",
  "field": "package-name-search-module__rhuPwa__field",
  "fieldOpen": "package-name-search-module__rhuPwa__fieldOpen",
  "input": "package-name-search-module__rhuPwa__input",
  "leadIcon": "package-name-search-module__rhuPwa__leadIcon",
  "lg": "package-name-search-module__rhuPwa__lg",
  "list": "package-name-search-module__rhuPwa__list",
  "option": "package-name-search-module__rhuPwa__option",
  "optionActive": "package-name-search-module__rhuPwa__optionActive",
  "optionBody": "package-name-search-module__rhuPwa__optionBody",
  "optionMeta": "package-name-search-module__rhuPwa__optionMeta",
  "optionName": "package-name-search-module__rhuPwa__optionName",
  "optionPrice": "package-name-search-module__rhuPwa__optionPrice",
  "panel": "package-name-search-module__rhuPwa__panel",
  "panelIn": "package-name-search-module__rhuPwa__panelIn",
  "seeAll": "package-name-search-module__rhuPwa__seeAll",
  "thumb": "package-name-search-module__rhuPwa__thumb",
  "trailIcon": "package-name-search-module__rhuPwa__trailIcon",
  "wrap": "package-name-search-module__rhuPwa__wrap",
});
